<template>
  <PriceRescueToastRegion
    close-button-class="admin-toast-dismiss"
    dismiss-label="Dismiss"
    region-class="admin-toast-region"
    :show-icon="false"
    toast-class="admin-toast"
    toast-tone-class-prefix="admin-toast"
    :toasts="toasts.toasts"
    @dismiss="toasts.dismiss"
  />
</template>

<script setup lang="ts">
import { PriceRescueToastRegion } from "@price-rescue/ui-components";

import { useAdminToastStore } from "../features/shared-ui/toast-store.js";

const toasts = useAdminToastStore();
</script>

<style scoped>
:global(.admin-toast-region) {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 110;
  display: grid;
  gap: 10px;
  width: min(360px, calc(100vw - 32px));
}

:global(.admin-toast) {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgba(23, 32, 51, 0.12);
  border-radius: 16px;
  padding: 12px;
  background: white;
  color: #172033;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.16);
}

:global(.admin-toast-success) {
  border-color: #98d5b3;
}
:global(.admin-toast-warning) {
  border-color: #f7c873;
}
:global(.admin-toast-error) {
  border-color: #f0a3a3;
}
</style>
